import { Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { brlCurrencyToLabel } from "../../../../../../../utils"
import { IRenda } from "../../../../../../../application/models"
// Icon
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'

export const RecorteRendaMensalFilterPreview = (props: {
    rendaMensalFilter?: IRenda
}) => {

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2} p={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Renda Presumida Mensal
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Stack
                            direction="row"
                            flexWrap="wrap"
                        >
                            {props.rendaMensalFilter && props.rendaMensalFilter.min &&
                                <Chip
                                    key={0}
                                    icon={<MonetizationOnIcon />}
                                    label={`de: R$ ${brlCurrencyToLabel(props.rendaMensalFilter && props.rendaMensalFilter.min)}`}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            }
                            {props.rendaMensalFilter && props.rendaMensalFilter.max &&
                                <Chip
                                    key={1}
                                    icon={<MonetizationOnIcon />}
                                    label={`até: R$  ${brlCurrencyToLabel(props.rendaMensalFilter && props.rendaMensalFilter.max)}`}
                                    sx={{
                                        m: 0.5
                                    }}
                                />
                            }
                        </Stack>
                    </Grid>
                </Paper>
            </Grid>
        </>
    )
}